import { createAction, props } from '@ngrx/store';

import { IFilterParam } from '@app/lib/interfaces';
import { IPaginationOptions } from '@app/lib/pagination/interfaces';
import { IResearchStudy, IResearchStudyDisplay, ITherapeuticArea } from 'projects/labcorp/clinical-trials-ui/src/lib/interfaces';

export const clearResearchStudyState = createAction(
  '[Studies] Clear Research Studies State'
);

export const clearResearchStudyToEdit = createAction(
  '[Studies] Clear Research Study to Edit'
);

export const createResearchStudy = createAction(
  '[Studies] Create Research Study',
  props<{ researchStudyData: IResearchStudy, groupData }>()
);

export const createResearchStudySuccess = createAction(
  '[Studies] Create Research Study Success',
);

export const createResearchStudyFailed = createAction(
  '[Studies] Create Research Study Failed',
);

export const getResearchStudies = createAction(
  '[Studies] Get Research Studies'
);

export const getResearchStudiesFailed = createAction(
  '[Studies] Get Research Studies Failed',
);

export const getResearchStudiesSuccess = createAction(
  '[Studies] Get Research Studies Success',
  props<{ researchStudies: IResearchStudyDisplay[], paginationOptions: IPaginationOptions, total: number }>(),
);

export const getTherapeuticAreas = createAction(
  '[Studies] Get Therapeutic Areas'
);

export const getTherapeuticAreasFailed = createAction(
  '[Studies] Get Therapeutic Areas Failed'
);

export const getTherapeuticAreasSuccess = createAction(
  '[Studies] Get Therapeutic Areas Success',
  props<{ therapeuticAreas: ITherapeuticArea[] }>(),
);

export const markResearchStudyToEdit = createAction(
  '[Studies] Mark Research Study to Edit',
  props<{ researchStudy: IResearchStudyDisplay}>(),
);

export const markResearchStudyToEditSuccess = createAction(
  '[Studies] Mark Research Study to Edit Success',
  props<{ researchStudy: IResearchStudyDisplay}>(),
);

export const markResearchStudyToEditFailed = createAction(
  '[Studies] Mark Research Study to Edit Failed',
);

export const setPageIndex = createAction(
  '[Studies] Set Page Index',
  props<{ index: number }>(),
);

export const updateEditedResearchStudy = createAction(
  '[Studies] Update Edited Research Study',
  props<{ researchStudyData: IResearchStudy, groupData: fhir4.Group }>(),
);

export const updateEditedResearchStudySuccess = createAction(
  '[Studies] Update Edited Research Study Success',
);

export const updateEditedResearchStudyFailed = createAction(
  '[Studies] Update Edited Research Study Failed',
);

export const updateFilterParams = createAction(
  '[Studies] Update List Navigator Filter Params',
  props<{ filterParam: IFilterParam }>()
);
